module.exports = __webpack_public_path__ + "img/1635666372395.2e99b02a.jpeg";